import ButtonWithLoadingState from '../ButtonWithLoadingState/ButtonWithLoadingState';

export default ButtonWithLoadingState;
